export const promoQRPrefix = 'code';

export const generatePromoQRValue = (id: string) => {
  return `${promoQRPrefix}/${id}`;
};
export const generatePromoQRFileName = (id: string) => {
  return `${promoQRPrefix}-${id}.png`;
};
